angular.module('impactx.approval').controller('ApprovalDenyOrStopCommentController', [
    '$scope',
    '$mdDialog',
    'title',
    'saveLabel',
    'themeFactory',
    'TranslationService',
    ApprovalDenyOrStopCommentController]);

function ApprovalDenyOrStopCommentController($scope, $mdDialog, title, saveLabel, themeFactory, TranslationService)
{
    $scope.title = title;
    $scope.saveLabel = saveLabel;
    $scope.abortLabel = TranslationService.get('abort');
    $scope.commentLabel = TranslationService.get('comment');
    $scope.theme = themeFactory.getTheme();
    $scope.comment = '';

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.answer = function ()
    {
        $mdDialog.hide($scope.comment);
    };
}